import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const filtersDirectoryRedirectRoute: InvariantJiraRoute = {
	name: 'filters-directory-redirect',
	path: '/ManageFilters.jspa',
};
